import * as Yup from "yup";
import moment from 'moment'
import Age from '../Dates/Age';
import { isFuture, isValid } from "date-fns";
import { Regex } from '../../Common/Constant';
import PremiumMode from "../../Product/SharedComponents/YourInformation/PremiumMode";

const { object, string, ref, boolean, array, number, date, mixed } = Yup

Yup.addMethod(Yup.string, 'isValidNumbersOnly', function (message, charLimit) {

  return Yup.string().test(`isValidNumbersOnly`, message, function (value) {
    const { path, createError } = this;

    let regex;
    if (charLimit) {
      regex = RegExp(`^[0-9]{${charLimit}}$`);
    }
    else {
      regex = RegExp(/^[0-9]*$/);
    }

    return regex.test(value) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidOfficeFA', function (message, dataLength,isFAOnly=false, isRequired = true) {

  return Yup.string().test(`isValidOfficeFA`, message, function (value) {
    const { path, createError } = this;

    let isValid = false;

    if (value !== null && value !== "" && value !== undefined) {
      // values that will return invalid response
      var incorrectFANums = isFAOnly ? ["000"]: ["000-000"];
      message = isFAOnly ? 'Invalid FA #. 3 digit FA # must be between 001 and 999.':'Invalid Office-FA #. 3 digit Office # must be between 001 and 999. 3 digit FA # must be between 001 and 999.';
      var length = incorrectFANums.length;
      for (var i = 0; i < length; i++) {
        if (incorrectFANums[i] === value) {
          isValid = false;
        }
      }

      const regexChars = isFAOnly ? Regex.FANum : Regex.OfficeFa;
      if (regexChars.test(value)) {
        isValid = true;
      }
      else {
        isValid = false;
      }
      if (value.length !== dataLength) {
        isValid = false;
      }
      if (value.endsWith(" ")) {
        isValid = false;
      }
    }
    else if(!isRequired)
      isValid = true;
    else {
      isValid = false;
      message = 'Office FA is required.';
    }

    return isValid || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidFAAccount', function (message, dataLength, isRequired = true) {

  return Yup.string().test(`isValidFAAccount`, message, function (value) {

    const { path, createError } = this;

    let isValid = false;
    let dataValue = value.replace('-', "");
    if (value !== null && value !== "" && value !== undefined) {
      // values that will return invalid response
      var incorrectFANums = ["000-000000", "101-000000"];
      message = 'Invalid Office-Account #. 3 digit Office # must be between 001 and 999. 6 digit Account # must be between 000001 and 999999.';
      var length = incorrectFANums.length;
      for (var i = 0; i < length; i++) {
        if (incorrectFANums[i] === value) {
          isValid = false;
        }
      }
      const regexChars = Regex.OfficeAccount;
      if (regexChars.test(value)) {
        isValid = true;
      }
      else {
        isValid = false;
      }
      if (value.endsWith(" ")) {
        isValid = false;
      }
      if (dataValue.length !== dataLength) {
        isValid = false;
      }
    }
    else if(!isRequired)
      isValid = true;
    else {
      isValid = false;
      message = 'Office FA Account is required.';
    }


    return isValid || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidPhone', function (message, charLimit) {

  return Yup.string().test(`isValidPhone`, message, function (value) {
    const { path, createError } = this;

    const regex = RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/);

    return regex.test(value) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidSSN', function (message, charLimit) {

  return Yup.string().test(`isValidSSN`, message, function (value) {
    const { path, createError } = this;

    const regex = RegExp(/(^\d{3}-?\d{2}-?\d{4}$)/);

    return regex.test(value) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidHeightInchString', function (message, minInch, maxInch) {

  return Yup.string().test(`isValidHeightInchString`, message, function (value) {
    const { path, createError } = this;

    let isValid = true;

    const heightFt = value.charAt(0);
    const heightIn = value.substring(5, 7);

    if (heightIn > 11) {
      isValid = false;
      message = 'Max of 11 inches';
    }

    if (!heightFt || heightFt === ' ') {
      isValid = false;
      message = 'Must provide height in feet';
    }

    if ((!heightIn || heightIn === '  ') && isValid) {
      isValid = false;
      message = 'Must provide height in inches';
    }
    const totalInches = parseInt(heightIn, 10) + parseInt((heightFt * 12), 10);

    if (isValid && totalInches < minInch) {
      isValid = false;
      message = `Height should be more than ${minInch} inches.`;
    }

    if (isValid && totalInches > maxInch) {
      isValid = false;
      message = `Height should be less than ${maxInch} inches.`;
    }

    return isValid || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidVisaNumber', function (message, charLimit) {

  return Yup.string().test(`isValidVisaNumber`, message, function (value) {
    const { path, createError } = this;

    const regex = RegExp(/[a-zA-Z]{3}\d{10}$/);

    return regex.test(value) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isFutureDate', function (message) {

  return Yup.string().test(`isFutureDate`, message, function (value) {
    const { path, createError } = this;
    const dates = value.split("/");
    let isDateValid = true;

    if ((value === '') || (dates && dates[0] === "__" && dates[1] === "__" && dates[2] === "____")) {
      isDateValid = false;
      message = "Date is required";
    }
    else if (!isValid(new Date(value))) {
      isDateValid = false;
      message = "Invalid date";
    }
    else if (isFuture(new Date(value))) {
      isDateValid = false;
      message = 'Cannot be in future'
    }

    return isDateValid || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidCoverageAmount', function (premium, specificPremium, premiumMode) {

  return Yup.string().test(`isValidCoverageAmount`, function (value) {

    const { path, createError } = this;
    let isValid = true;
    let message;
    var coverageValue = Number(value.replace(/[^0-9.-]+/g, ""));
    let specificPremiumAmount;
    if(premium === "specificPremium"){
      specificPremiumAmount = Number(specificPremium.replace(/[^0-9.-]+/g, ""));
    }

    const premiumModeValue = PremiumMode(premiumMode);
    const premiumValue = premium === 'specificPremium' ? specificPremiumAmount : premium;
    const coverageAmount = premiumValue / premiumModeValue;

    if (coverageValue !== "" && coverageValue < 10000 || coverageValue > 2000000) {
      isValid = false;
      message = 'The field Coverage (Death Benefit) must be between 10000 and 2000000.';
    }

    if(value === ""){
      isValid = false;
      message = 'Coverage is required.';
    }

    return isValid || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidAmountRange', function (msg, minAmount, maxAmount, errorMessage) {

  return Yup.string().test(`isValidAmountRange`, msg, function (value) {
    const { path, createError } = this;
    let isValid = true;
    let message;
    var premiumValue = Number(value.replace(/[^0-9.-]+/g, ""));

    if (premiumValue < minAmount) {
      isValid = false;
      message = errorMessage;
    }

    if (premiumValue > maxAmount) {
      isValid = false;
      message = errorMessage;
    }

    if(value === ""){
      isValid = false;
      message = msg;
    }

    return isValid || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidBirthdate', function (message, minAge, maxAge) {

  return Yup.string().test(`isValidBirthdate`, message, function (value) {
    const { path, createError } = this;

    value = moment(new Date(value));

    const age = Age(value);
    const currentDate = moment(new Date());

    let isWithinAgeRange = true

    if (maxAge) {
      if (age > maxAge) {
        isWithinAgeRange = false;
        message = 'You are over the maximum age';
      }
    }

    if (minAge) {
      if (age < minAge) {
        isWithinAgeRange = false;
        message = 'You are under the minimum age';
      }
    }

    if (value > currentDate) {
      isWithinAgeRange = false;
      message = 'Cannot be in future'
    }

    return (value.isValid() && isWithinAgeRange) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidateAgeAndDifferenceFromBirthdate', function (message, minAge, maxAge, specificMessage) {
 
  return Yup.string().test(`isValidateAgeAndDifferenceFromBirthdate`, message, function (value) {
    const { path, createError, options } = this;
 
    const stringValue = value;
    value = moment(new Date(value));
    const regex = RegExp(/^(\d{2})\/(\d{2})\/\d{4}$/);
    
    if (!stringValue) {
      return createError({ path, message: "Date of Birth is required." });
    }
    // validate birthdate with regEx
    if (!value.isValid() || !regex.test(stringValue)) {
      return (createError({ path, message: message }));
    }
 
    const age = Age(value);
    const currentDate = moment(new Date());
 
    if (value > currentDate) {
      return (createError({ path, message: 'Cannot be in future' }));
    }
 
    if (maxAge) {
      if (age > maxAge) {
        return (createError({ path, message: specificMessage }));
      }
    }
 
    if (minAge) {
      if (age < minAge) {
        return (createError({ path, message: specificMessage }));
      }
    }
    return true;
  })
})

Yup.addMethod(Yup.string, 'isValidNoQuotes', function (message) {

  return Yup.string().test(`isValidNoQuotes`, message, function (value) {
    const { path, createError } = this;

    const regex = RegExp(/^[^'"]*$/);

    return regex.test(value) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidAlphanumeric', function (message, charLimit) {

  return Yup.string().test(`isValidAlphanumeric`, message, function (value) {
    const { path, createError } = this;

    let regex;
    if (charLimit) {
      regex = RegExp(`^[a-zA-Z0-9]{${charLimit}}$`);
    }
    else {
      regex = RegExp(/^[a-zA-Z0-9]*$/);
    }

    return regex.test(value) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidAddress', function (message) {

  return Yup.string().test(`isValidAddress`, message, function (value) {
    const { path, createError } = this;

    let regex;
    regex = RegExp(/^[a-zA-Z0-9 ]*$/);

    return regex.test(value) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidNameLimitedSpecialChar', function (message, isRequired, address) {

  return Yup.string().test(`isValidNameLimitedSpecialChar`, message, function (value) {
    const { path, createError } = this;

    const firstChar = value.slice(0, 1);
    const lastChar = value.slice(-1);

    const firstAndLastCharRegex = RegExp(/^[()!#&*+,.\/:;=?@^_`|~0-9a-zA-ZÀ-ÖØ-öø-ÿ'-]$/);
    const fullNameRegex = RegExp(/^([ ()!#&*+,.\/:;=?@^_`|~0-9a-zA-ZÀ-ÖØ-öø-ÿ'-]*)$/
    );

    const isValid = firstAndLastCharRegex.test(firstChar) &&
      firstAndLastCharRegex.test(lastChar) &&
      fullNameRegex.test(value) && value.split(',').length <= 2 && value.split('.').length <= 2;

    if (isRequired === false) {
      if (!isValid && value !== "") {
        message = "Invalid characters entered in field.";
      }
      else {
       return true;
      }
    }

    if (isRequired === true) {
      if  (!isValid && value !== "") {
        message = "Invalid characters entered in field.";
      }
      else if (value === "") {
        message = this.message;
      }
    }
   return isValid || createError({ path, message });
  })
})
Yup.addMethod(Yup.string, 'isValidHeightString', function (message, minFt, isHeightRequired, maxFt = 7) {

  return Yup.string().test(`isValidHeightString`, message, function (value) {
    const { path, createError } = this;

    let isValid = true;

    const heightFt = value.charAt(0);
    const heightIn = value.substring(5, 7);

    if (heightFt > maxFt) {
      isValid = false;
      message = `Max of ${maxFt} feet`
    }

    if (heightFt < minFt) {
      isValid = false;
      message = `Minimum of ${minFt} feet`
    }

    if (heightIn > 11) {
      isValid = false;
      message = 'Max of 11 inches'
    }

    if (!heightFt || heightFt === ' ') {
      isValid = false;
      message = 'Must provide height in feet'
    }

    if ((!heightIn || heightIn === '  ') && isValid) {
      isValid = false;
      message = 'Must provide height in inch'
    }

    return isValid || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidWeightString', function (message, minWeight, maxWeight, isWeightRequired) {

  return Yup.string().test(`isValidWeightString`, message, function (value) {
    const { path, createError } = this;

    let isValid = true;
    let validateMessage = "";

    if (value === "") {
      isValid = false;
      validateMessage = "Weight is required.";
    }
    const weight = value ? (value.includes('pounds') ? value.replace('pounds', '').replace(' ', '') : value) : '';

    if (isValid && weight > maxWeight) {
      isValid = false;
      validateMessage = message === "" ? `Weight should be less than ${maxWeight} pounds.` : message;
    }

    if (isValid && weight < minWeight) {
      isValid = false;
      validateMessage = message === "" ? `Weight should be more than ${minWeight} pounds.` : message;
    }

    return isValid || createError({ path, message: validateMessage });
  })
})

Yup.addMethod(Yup.string, 'isValidCoverageAmountString', function (message, minCoverageAmount, maxCoverageAmount) {

  return Yup.string().test(`isValidCoverageAmountString`, message, function (value) {
    const { path, createError } = this;

    let isValid = true;
    let validateMessage = "";

    if (value === "") {
      isValid = false;
      validateMessage = message;
    }
    const coverageAmount = value ?  parseInt(value.replace(',', '').replace('$', ''),10) : '';

    if (isValid && minCoverageAmount > coverageAmount) {
      isValid = false;
      validateMessage = `Total Premium must be greater than or equal to ${minCoverageAmount}.`;
    }

    if (isValid && maxCoverageAmount < coverageAmount) {
      isValid = false;
      validateMessage = `Total Premium must be less than or equal to ${maxCoverageAmount}.`;
    }

    return isValid || createError({ path, message: validateMessage });
  })
})

Yup.addMethod(Yup.string, 'isValidAmericoHeightString', function (message, minInch = 58, maxInch = 80) {
  return Yup.string().test(`isValidAmericoHeightString`, message, function (value) {
    const { path, createError } = this;

    let isValid = true;

    const heightFt = value.charAt(0);
    const heightIn = value.substring(5, 7);
    const totalHeightInches = parseInt(heightFt, 10) * 12 + parseInt(heightIn, 10);

    if (totalHeightInches > maxInch) {
      isValid = false;
      message = `Height should be less than ${maxInch} inches.`
    }

    if (totalHeightInches < minInch) {
      isValid = false;
      message = `Height should be more than ${minInch} inches.`
    }

    if (heightIn > 11) {
      isValid = false;
      message = 'Max of 11 inches'
    }

    if (!heightFt || heightFt === ' ') {
      isValid = false;
      message = 'Must provide height in feet'
    }

    if ((!heightIn || heightIn === '  ') && isValid) {
      isValid = false;
      message = 'Must provide height in inch'
    }

    return isValid || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidSpecificStartDate', function (message, piBirthdate) {

  return Yup.string().test(`isValidSpecificStartDate`, message, function (value) {
    const { path, createError } = this;

    let validDate = true;

    const selectedDate = moment(new Date(value));
    const date = selectedDate.date();

    const currentDate = moment().startOf('day');
    const thirtyDaysOutDate = moment(currentDate).add(30, 'd');

    const nextBirthday = moment(new Date(piBirthdate));
    nextBirthday.year(currentDate.year());
    if (currentDate > nextBirthday) {
      nextBirthday.year(currentDate.year() + 1);
    }

    //moment converting 31st sep 2020 to 1 oct 2020, so  for this type of case use indexof
    if (!selectedDate.isValid()) {
      message = "Invalid date";
    }
    else if (CompareSpecificStartDate(selectedDate, currentDate)) {
      validDate = false;
      message = 'Start date cannot be in past';
    }
    else if (selectedDate > thirtyDaysOutDate) {
      validDate = false;
      message = 'Start date must be within 30 days and cannot be on the 29th, 30th, or 31st of the month';
    }
    else if (nextBirthday.isBetween(currentDate, thirtyDaysOutDate) && selectedDate > nextBirthday) {
      validDate = false;
      message = 'Your payment date must occur before your next birthday';
    }
    else if (date === 29 || date === 30 || date === 31 || value.indexOf('/31/') > -1) {
      validDate = false;
    }

    return (selectedDate.isValid() && validDate) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidAlphaNumericCharacters', function (message) {

  return Yup.string().test(`isValidAlphaNumericCharacters`, message, function (value) {
    const { path, createError } = this;

    let regex;
    regex = RegExp(/^[a-zA-Z0-9#$%()-]*$/);
    return regex.test(value) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidAccountNumber', function (message) {

  return Yup.string().test(`isValidAccountNumber`, message, function (value) {
    const { path, createError } = this;

    let regex;
    regex = RegExp(/^[a-zA-Z0-9# ]+$/);
    return regex.test(value) || createError({ path, message });
  });
});



//   return Yup.string().test(`isValidAlphaNumericCharacters`, message, function (value) {
//     const { path, createError } = this;

//     let regex;
//     regex = RegExp(/^[a-zA-Z0-9#$%()-]*$/);
//     return regex.test(value) || createError({ path, message });
//   })
// })

const CompareSpecificStartDate = (startDate, currentDate) => {
  //Allow 28th date
  const unavailableDraftDates = [29, 30, 31];
  const isSameMonth = startDate.month() === currentDate.month();
  const isSameYear = startDate.year() === currentDate.year();
  if (startDate < currentDate && startDate.date() === 28 && unavailableDraftDates.includes(currentDate.date()) && isSameMonth && isSameYear) {
    return false;
  } else if (startDate < currentDate) {
    return true;
  }
}

Yup.addMethod(Yup.string, 'ValidateDriversLicense', function (message, dlState) {

  return Yup.string().test(`ValidateDriversLicense`, message, function (value) {
    const { path, createError } = this;
    let regex;
    let isValid = true;

    switch (dlState) {
      case "AL":
      case "AK":
      case "DE":
        regex = RegExp(/^\d{1,7}$/);
        break;
      case "AZ":
        regex = RegExp(/^([A-Z]\d{1,8}|[A-Z]{2}\d{2,6}|\d{9})$/);
        break;
      case "AR":
        regex = RegExp(/^\d{4,9}$/);
        break;
      case "CA":
      case "NE":
        regex = RegExp(/^[A-Z]\d{7}$/);
        break;
      case "CO":
        regex = RegExp(/^(\d{9}|[A-Z]\d{3,6}|[A-Z]{2}\d{2,5})$/);
        break;
      case "CT":
      case "MS":
        regex = RegExp(/^\d{9}$/);
        break;
      case "DC":
        regex = RegExp(/^(\d{7}|\d{9})$/);
        break;
      case "FL":
      case "MD":
      case "MN":
        regex = RegExp(/^[A-Z]\d{12}$/);
        break;
      case "GA":
      case "TN":
        regex = RegExp(/^\d{7,9}$/);
        break;
      case "HI":
        regex = RegExp(/^(\d{9}|[A-Z]\d{8})$/);
        break;
      case "ID":
        regex = RegExp(/^([A-Z]{2}\d{6}[A-Z]|\d{9})$/);
        break;
      case "IL":
        regex = RegExp(/^([A-Z]\d{11,12})$/);
        break;
      case "IN":
        regex = RegExp(/^([A-Z]{1}\d{9}|\d{9,10})$/);
        break;
      case "IA":
        regex = RegExp(/^(\d{3}[A-Z]{2}\d{4}|\d{9})$/);
        break;
      case "KS":
        regex = RegExp(/^(\d{9}|[A-Z]\d{8}|[A-Z]\d{1}[A-Z]\d{1}[A-Z])$/);
        break;
      case "KY":
        regex = RegExp(/^(\d{9}|[A-Z]\d{8,9})$/);
        break;
      case "LA":
      case "OR":
        regex = RegExp(/^\d{1,9}$/);
        break;
      case "ME":
        regex = RegExp(/^(\d{7,8}|\d{7}[A-Z])$/);
        break;
      case "MA":
        regex = RegExp(/^([A-Z]\d{8}|\d{9})$/);
        break;
      case "MI":
        regex = RegExp(/^([A-Z]\d{10}|[A-Z]\d{12})$/);
        break;
      case "MO":
        regex = RegExp(/^(\d{9}|\d{9}[A-Z]{1}|\d{8}[A-Z]{2}|[A-Z]{1}\d{5,9}|[A-Z]{1}\d{6}[R])$/);
        break;
      case "MT":
        regex = RegExp(/^(\d{9}|[A-Z]\d[\dA-Z]\d{2}[A-Z]{2}\d|\d{13}|\d{14}|[A-Z]\d{8})$/);
        break;
      case "NV":
        regex = RegExp(/^(\d{9}|\d{10}|\d{12}|[X]\d{8})$/);
        break;
      case "NH":
        regex = RegExp(/^\d{2}[A-Z]{3}\d{5}$/);
        break;
      case "NJ":
        regex = RegExp(/^[A-Z]\d{14}$/);
        break;
      case "NM":
        regex = RegExp(/^\d{8,9}$/);
        break;
      case "NY":
        regex = RegExp(/(^[A-Z]{1}[0-9]{7}$)|(^[A-Z]{1}[0-9]{18}$)|(^[0-9]{8}$)|(^[0-9]{9}$)|(^[0-9]{16}$)|(^[A-Z]{8}$)/);
        break;
      case "NC":
        regex = RegExp(/^\d{1,12}$/);
        break;
      case "ND":
        regex = RegExp(/^(\d{9}|[A-Z]{3}\d{6})$/);
        break;
      case "OH":
        regex = RegExp(/^([A-Z]{1}\d{4,8}|[A-Z]{2}\d{3,7}|\d{8})$/);
        break;
      case "OK":
        regex = RegExp(/^(\d{9}|[A-Z]{1}\d{9})$/);
        break;
      case "PA":
        regex = RegExp(/^\d{8}$/);
        break;
      case "RI":
        regex = RegExp(/^(\d{7}|[A-Z]{1}\d{6})$/);
        break;
      case "SC":
        regex = RegExp(/^\d{5,11}$/);
        break;
      case "SD":
        regex = RegExp(/(^[0-9]{6,10}$)|(^[0-9]{12}$)/);
        break;
      case "TX":
        regex = RegExp(/^\d{7,8}$/);
        break;
      case "UT":
        regex = RegExp(/^\d{4,10}$/);
        break;
      case "VT":
        regex = RegExp(/^\d{7}[\dA]$/);
        break;
      case "VA":
        regex = RegExp(/^(\d{9}|[A-Z]\d{8,11})$/);
        break;
      case "WA":
        regex = RegExp(/^(?=.{12}$)[A-Z]{1,7}[A-Z0-9\\*]{4,11}$/);
        break;
      case "WV":
        regex = RegExp(/^(\d{7}|[A-Z]{1,2}\d{5,6})$/);
        break;
      case "WI":
        regex = RegExp(/^[A-Z]\d{13}$/);
        break;
      case "WY":
        regex = RegExp(/^\d{9,10}$/);
        break;
      default:
        regex = RegExp(/^[a-zA-Z0-9]*$/);
        isValid = false;
        break;
    }

    return (regex.test(value) && isValid) || createError({ path, message });
  })
})

Yup.addMethod(Yup.string, 'isValidPremiumGoal', function(message, min, max){

  return Yup.string().test(`isValidPremiumGoal`, message, function (value) {
    const { path, createError } = this;

    let isValid = true;
    let validateMessage = "";
    let premium = parseFloat(value.replaceAll(',','').replace('$',''));
    if (value === "") {
      isValid = false;
      validateMessage = "Submitted Premium Goal is required";
    }

    if (isValid && premium > max) {
      isValid = false;
      validateMessage = 'Submitted Premium Goal must be between 1 and 1000000';
    }

    if (isValid && premium <= min) {
      isValid = false;
      validateMessage = 'Submitted Premium Goal must be greater than current Submitted Premium count';
    }

    return isValid || createError({ path, message: validateMessage });
  })

})
// any separate yup validators, so you don't have to ref customValidators everytime
export { object, string, ref, boolean, array, number, date, mixed }


// you wont need to import yup module separately with this
export { Yup as customValidators }



// WEBPACK FOOTER //
// ./src/components/Helpers/Validators/customValidators.js